import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, heroText, logo, mobileHero, mobileHeroText } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="95vh"
          w="100%"
          image={`url(${mobileHero}) bottom / cover no-repeat`}
          column
        >
          <CFView
            h="95vh"
            textCenter
            column
            justifyBetween
            alignCenter
            mt="10%"
            w="100%"
          >
            <CFImage
              w="95%"
              maxWidth="350px"
              src={mobileHeroText}
              alt="To Dine For Eatery hero text"
              zIndex={98}
            />
            <CFView mb="40px" pulsate>
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="100vh"
          maxHeight="650px"
          w="100%"
          image={`url(${hero}) center / cover no-repeat`}
          zIndex={90}
          column
        >
          <CFView column justifyCenter alignStart ml="6%" h="100%" mt="15px">
            <CFImage
              w="55%"
              maxWidth="420px"
              src={heroText}
              alt="To Dine For Eatery hero text"
              zIndex={98}
            />
            <CFView mt="30px" pulsate>
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
